var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgBarnPlus(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M19 3.6l8.813 5.906c.125.063.187.172.187.328v1.688c.031.281-.094.422-.375.422h-1.219V27.13c.032.281-.093.422-.375.422H4.421c-.28 0-.421-.14-.421-.422v-9.61c0-.124.063-.234.188-.327l4.177-2.311a5.523 5.523 0 001.508.105l-5.076 2.815v8.953H6.39v-5.203c0-.281.14-.422.421-.422h2.391c.281 0 .422.14.422.422v5.203h1.594v-12.03c.275-.09.542-.202.797-.334v12.364h3.187v-7.594c0-.28.14-.421.422-.421H22c.281 0 .422.14.422.421v7.594h3.187V11.334l-6.797-4.5-3.815 2.526-.001-.081a5.514 5.514 0 00-.092-.807l3.674-2.435c.156-.125.297-.125.422 0l7.219 4.782c.125.093.187.203.187.328h.797v-1.125l-8.39-5.625-4.284 2.872a5.486 5.486 0 00-.376-.703L18.578 3.6c.156-.094.297-.094.422 0zM8.828 21.928h-1.64v2.016h.421c.282 0 .422.133.422.398 0 .266-.14.399-.422.399h-.421v2.015h1.64v-4.828zm9.61-2.39H16v7.218h2.438v-2.812h-.422c-.25 0-.375-.133-.375-.399 0-.265.125-.398.375-.398h.421v-3.61zm3.187 0h-2.39v3.609h.374c.282 0 .422.133.422.398 0 .266-.14.399-.422.399h-.375v2.812h2.391v-7.219zm2.016-7.594c.25 0 .375.125.375.375v4.828c0 .25-.125.375-.375.375h-9.61c-.281 0-.422-.125-.422-.375v-3.991c.324-.364.6-.771.82-1.212h9.212zm-6 2.437c-1.032.5-1.579 1.281-1.641 2.344h3.234a2.748 2.748 0 00-.75-1.64c0-.032-.015-.063-.047-.094a2.577 2.577 0 00-.796-.61zm2.39 0c-.25.125-.484.266-.703.422.406.594.64 1.234.703 1.922h1.594c-.031-1.063-.563-1.844-1.594-2.344zm3.188-1.64h-8.813v3.984h.797a3.4 3.4 0 01.656-1.875 3.745 3.745 0 011.594-1.266.234.234 0 01.281 0c.407.157.75.375 1.032.657a3.43 3.43 0 011.078-.657.234.234 0 01.281 0 3.745 3.745 0 011.594 1.266 3.4 3.4 0 01.656 1.875h.844v-3.984z"
  }), React.createElement("path", {
    d: "M10.076 11.418V10.08h1.343a.58.58 0 100-1.162h-1.343V7.582a.582.582 0 00-1.164 0V8.92H7.58a.58.58 0 100 1.162h1.33v1.337a.582.582 0 001.165 0z"
  }), React.createElement("path", {
    d: "M9.5 4a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 1a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"
  })));
}

export default SvgBarnPlus;